export enum LogoutType {
    USER_INITIATED = 'USER_INITIATED',
    INACTIVITY = 'INACTIVITY',
    ON_PASSWORD_CHANGE = 'ON_PASSWORD_CHANGE'
}
